import tw from "twin.macro";
import styled from "styled-components";

 export const BlockImage = styled.div(props => [
    `background-image: url("${props.imageSrc}");`,
    tw`h-147 w-147 3xs:h-70pp xxs:h-70pp xs:h-72 sm:h-72 md:h-72 lg:h-96 xl:h-147 2xl:h-147 3xs:w-70pp xxs:w-70pp xs:w-80 sm:w-72 md:w-96 lg:w-130 xl:w-147 2xl:w-147
    bg-contain bg-no-repeat`
  ]);